var React = require('react');

function Airport (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2_1_"},React.createElement("g",{"id":"Icons"},React.createElement("path",{"fill":"currentColor","className":"st0","d":"M46.4,24.4C46.4,24.3,28,14,28,14V4c0-2.2-1.8-4-4-4s-4,1.8-4,4v10L1.3,24.6C0.5,25.1,0,26,0,27\n\t\t\tc0,1.7,1.3,3,3,3c0,0,0,0,0,0c0.3,0,0.6,0,0.9-0.1L20,25v15l-6.1,4.3c-0.2,0.1-0.3,0.2-0.4,0.4C13.2,45.1,13,45.5,13,46\n\t\t\tc0,1.1,0.9,2,2,2c0.1,0,0.2,0,0.3,0l8.7-2.9l8.3,2.8C32.5,48,32.8,48,33,48c1.1,0,2-0.9,2-2c0-0.4-0.1-0.9-0.4-1.2\n\t\t\tc-0.1-0.2-0.3-0.4-0.5-0.5L28,40V25l16,4.8c0.3,0.1,0.7,0.2,1,0.2c1.7,0,3-1.3,3-3C48,25.9,47.4,24.9,46.4,24.4z"}))));
}

Airport.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 48 48","style":{"enableBackground":"new 0 0 48 48"},"xmlSpace":"preserve"};

module.exports = Airport;

Airport.default = Airport;
